module.exports = __webpack_public_path__ + "img/nelia.e3875dd4.png";